import { render } from "./CartItem.vue?vue&type=template&id=a0a41d94&scoped=true"
import script from "./CartItem.vue?vue&type=script&lang=ts"
export * from "./CartItem.vue?vue&type=script&lang=ts"

import "./CartItem.vue?vue&type=style&index=0&id=a0a41d94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a0a41d94"

export default script